module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.ff9870a7.jpg";